export default __webpack_public_path__ + "static/media/lock.2d5800cf.svg";